import { Env } from '@stencil/core';
import { scrollToTop } from '../../../../common/hair-quiz-vto/utils/utils';
let analyticsService = null;

const handleQuizScreenOnLoad = async ({ event, data }) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    scrollToTop();
    console.log('@AIBA[handleQuizScreenOnLoad]', event);

    try {
      const quizScreenData = data;
      let {currentQuizIndex, selectedOptions, quizPlainIndex, currentIntroIndex} = await handlers.getQuizState();
   
      let formattedData =await  quizFormattedDatafn(quizScreenData)
      await handlers.updateQuizData(quizScreenData);

      await handlers.updateQuizFormattedData(formattedData);
      return { showIntro: false, showQuiz: true, currentIntroIndex, currentQuizIndex, selectedOptions, quizPlainIndex, hideNextButton: 'showOnFirstQuestion' };
    } catch (err) {
      console.error(err);
    }
  }
};

const handleQuizScreenWillLoad =()=>{
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    analyticsService?.registerEvent('event1', { page: `aiba quiz page` });
  }
}

const quizFormattedDatafn= async (quizScreenData)=>{
  if (window['AIBA'] && window['AIBA']['utils']) {
      const handlers = window['AIBA']['utils'];
      let { selectedOptions,  selectedOptionsWithId, } = await handlers.getQuizState();
      let totalQuestions = 0;
      console.info(totalQuestions);
      let formattedDataValue = quizScreenData.map(({ data: { quiz } }) => {
        return quiz.data.questions.map(question => {
          const { questionId, questionType, questionText, groupId, answers, conditionalValue, hide = '' } = question.data;
          if (groupId !== 'userPI') {
            const answersData = answers.data.map(({ answerId, answerText, surveyQuestionAnswerId }) => {
              return { answerId, title: answerText, surveyQuestionAnswerId };
            });
            if (conditionalValue) {
              const conditionDetails = conditionalValue.split('-');
              let flag = 0;
              Object.keys(selectedOptions).forEach(key => {
                let selectedOption = selectedOptions[key];
                if (selectedOption?.includes(conditionDetails[1])) {
                  Object.keys(selectedOptionsWithId).forEach(keyIds => {
                    for (const key in selectedOptionsWithId) {
                      console.log(keyIds);
                      if (key != '3967' && selectedOptionsWithId[key][0] === selectedOption[0]) {
                        flag = 1;
                      }
                    }
                  });
                }
              });
              if (flag === 1) {
                totalQuestions += 1;
                return {
                  groupId,
                  questionId,
                  type: questionType,
                  title: questionText,
                  answers: answersData,
                  conditionalValue: conditionalValue,
                  hide: hide,
                };
              }
            } else {
              
                totalQuestions += 1;
                return {
                  groupId,
                  questionId,
                  type: questionType,
                  title: questionText,
                  answers: answersData,
                };
              
            }
          }
        });
      });
      const formattedData = [];
      formattedDataValue.map(elem => {
        elem.map((item, index) => {
          if (index >= 0) {
            formattedData.push(item);
          }
        });
      });
      return formattedData;
  }
}

export const getQuizData = async quiz => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    if (!handlers) return;

    const selectedOptions = await handlers.getQuizOptionSelected();
    const selectedOptionsFlat = Object.values(selectedOptions).flat();
    const quizGroupIDs = ['yourSkin', 'yourSkinGoals'];

    if (!quiz) return;

    const newQuiz = quiz.map(item => {
      if(item){
        const newAnswersArray = item.answers.map(({ title, ...rest }) => ({
          ...rest,
          answerText: title,
        }));

        return {
          ...item,
          answers: quizGroupIDs.includes(item.groupId) ? newAnswersArray.filter(({ answerId }) => selectedOptionsFlat.includes(answerId)) : newAnswersArray,
        };
      }
    });

    return { newQuiz };
  }
};



const getProductsApi = async handlers => {
  const { productRecommendation, brand } = await handlers.getConfig();
  const config = await handlers.getConfig();
  const meta = {
    type: 'style',
    categories: productRecommendation.categories,
    division: brand.division,
    brandName: brand.brand,
    locale: brand.locale,
    version: brand.version,
    limit: 11,
    offset: 0,
    journey_type: brand.journey_type,
  };
  const quizPayload = await handlers.getQuizPayload();

  const QuizData = quizPayload.reduce((total, curr) => {
    const ans = curr.answers.map(i => {
      return { answerId: i.answerId, title: i.title };
    });
    total.push({
      ...curr,
      answers: ans,
    });
    return total;
  }, []);

  const assessmentResults = {
    quiz: QuizData,
  };
  const result = await handlers.recommendationService.getRecommendedProducts(
    assessmentResults,
    `${Env.AIBA_SERVICES_BASE_URL}${Env[config.apiConfig.apiEndpoints.recommendations]}`,
    Env.API_KEY_AIBA_SERVICES,
    meta,
  );
  result?.map(items => {
    items?.recommendation?.map((recom_style, index) => {
      if (index >= 10) {
        items?.other?.push(recom_style);
      }
    });
    items.recommendation = items?.recommendation?.filter((_element, index) => index < 10);
  });
  await handlers.setRecommendedStyles(result);
};



export const handleAnalyzeScreenOnLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    await getProductsApi(handlers);
    handlers.getNextJourney('analyze_screen');
  }
};

const prepareEventData = async (event, quizFormattedData, selectedOptions, questionsList, selectedOptionsWithId) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const sanitizedQuizData = quizFormattedData.filter(i => i);
    const questionIdList = quizFormattedData.filter(i => i).map(i => i.questionId);

    console.info('event,total', sanitizedQuizData.length, event, selectedOptions);
    const eventData = {};

    eventData['component'] = `Aiba - Hair Analysis`;
    eventData['label'] = `${sanitizedQuizData.length} questions answered at once`;
    eventData['action'] = 'DT results (all at once)';
    eventData['questionId'] = 'combined questions';
    eventData['subattributes'] = [];

    for (var quesId of questionIdList) {
      const selectedQuestionId = Object.keys(questionsList).find(key => {
        return questionsList[key].data.questionId === quesId;
      });
      const currentQuestion = questionsList[selectedQuestionId].data;
      const quesOptions = currentQuestion.answers['data'];

      if (quesOptions.length) {
        let selectedAnswerTextArray = [];
        //get selected answerText from all answers
        if (selectedOptionsWithId && selectedOptionsWithId[quesId]?.length > 1) {
          quesOptions.map(option => {
            if (selectedOptionsWithId[quesId].includes(option['answerId'])) {
              selectedAnswerTextArray.push(option['answerText']);
            }
          });
          const selectedAnswerTextString = selectedAnswerTextArray.join(', ');
          eventData['subattributes'].push({
            question: currentQuestion?.questionText,
            answer: selectedAnswerTextString,
          });
        } else {
          const answerObject = currentQuestion.answers.data.find(i => i.answerId === selectedOptionsWithId?.[quesId][0]);
          eventData['subattributes'].push({
            question: currentQuestion?.questionText,
            answer: answerObject?.answerText ? answerObject?.answerText : answerObject,
          });
        }
      }
    }
    return eventData;
  }
};


const handleAnalyzeQuestionClick = async event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    let { currentIntroIndex, currentQuizIndex, quizData, selectedOptions, quizFormattedData, selectedOptionsWithId } = await handlers.getQuizState();
    let error;
    const questionIds = [];
    quizFormattedData.map(elem => {
      if(elem){
      const question = quizData[currentIntroIndex].data.quiz.data.questions.find(i=> i.data.questionId===elem?.questionId);
      question?.data?.questionMandatory &&
       questionIds.push(elem?.questionId);
      }
    });

    questionIds.forEach(item => {
      if (!selectedOptionsWithId) {
        let event = new CustomEvent('event-options-error', { detail: `${item}` });
        document.dispatchEvent(event);
        error = true;
        return quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.questionMandatory;
      } else {
        if (!selectedOptionsWithId[item] && Object.keys(selectedOptionsWithId).length > 0) {
          let event = new CustomEvent('event-options-error', { detail: `${item}` });
          document.dispatchEvent(event);
          error = true;
          return quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.questionMandatory;
        }
      }
    });

    //if error in form
    if(error){
       scrollToTop();
       return;
    }
    
    
    const userPI = quizData.find(({ data }) => data['groupId'] === 'userPI');
    let length = userPI?.data?.quiz?.data?.questions?.length;
    let quizPayloadData = [];
    if (selectedOptionsWithId && Object.keys(selectedOptionsWithId).length > 0) {
      const quizNewData = quizFormattedData.flat(1);
      quizPayloadData = quizNewData
        .map(question => {
          if (selectedOptionsWithId[question?.questionId]) {
            const valArray = selectedOptionsWithId[question?.questionId];
            const answers = question.answers.filter(answer => valArray.includes(answer.answerId));
            if (answers.length > 0) {
              return { ...question, answers };
            }
          }
          return null;
        })
        .filter(item => item);
    } else {
      const quizNewData = quizFormattedData.flat(1);
      quizPayloadData = quizNewData
        .map((question, index) => {
          if (selectedOptions[index + (length ? length : 0)]) {
            const valArray = selectedOptions[index + (length ? length : 0)];
            const answers = question.answers.filter(answer => valArray.includes(answer.answerId));
            if (answers.length > 0) {
              return { ...question, answers };
            }
          }
          return null;
        })
        .filter(item => item);
    }

    analyticsService = handlers.analyticsService;

    let questionsList = quizData[currentIntroIndex].data.quiz.data.questions;

    event['data'] = await prepareEventData(event, quizFormattedData, selectedOptions, questionsList, selectedOptionsWithId);
    console.log(event['data']);

  await analyticsService?.registerEvent('event24', event);

    analyticsService?.registerEvent('event1', { page: 'vto selfie wrapper screen' });
    const restructureQuizPayloadDataObj: any = {};
    quizPayloadData.forEach((question: any) => {
      if (question?.conditionalValue) {
        const questionId = question?.conditionalValue.split('-')[0];
        if (restructureQuizPayloadDataObj[questionId]) {
          const actualQuestionData = { ...restructureQuizPayloadDataObj[questionId] };
          actualQuestionData['answers'] = [...question?.answers];
          restructureQuizPayloadDataObj[questionId] = { ...actualQuestionData };
        }
      } else {
        restructureQuizPayloadDataObj[question?.questionId] = { ...question };
      }
    });
    const restructureQuizPayloadData: any = [];
    Object.keys(restructureQuizPayloadDataObj).forEach(function (key) {
      restructureQuizPayloadData.push(restructureQuizPayloadDataObj[key]);
    });
    await handlers.updateQuizPayload(restructureQuizPayloadData);
    handleAnalyzeScreenOnLoad();
    await handlers.setKeepPhoto(false);
    await handlers.setHideVTOScreen(false);
    handlers.scrollToTop = true;
    await handlers.getNextJourney('quiz_screen');
    if (document.getElementById('YMK-module')) {
      document.getElementById('YMK-module').style.display = 'block';
    }
  }
};

const selectedOptions = async questionId => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const { selectedOptionsWithId } = await handlers.getQuizState();

    if (selectedOptionsWithId && Object.keys(selectedOptionsWithId).length > 0) {
      return selectedOptionsWithId[questionId] ? selectedOptionsWithId[questionId] : [];
    } else {
      return selectedOptionsWithId && selectedOptionsWithId.length? [...selectedOptionsWithId] : [];
    }
  }
};

const handleQuizOptionSelected = async (userSelectedOptions, questionId) => {
  
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const { quizPlainIndex, selectedOptionsWithId, quizData, selectedOptions } = await handlers.getQuizState();
    let index = quizPlainIndex

    const conditionalQues = quizData[0].data.quiz.data.questions.reduce((total,curr)=>{
      curr.data.questionMode && total.push(curr.data.questionId);
      return total
     },[]);

    const questionWithOptions =   [...new Set(quizData[0].data.quiz.data.questions.reduce((total,curr)=>{
      curr.data.conditionalValue && total.push(curr.data.conditionalValue.split('-')[0]);
      return total
     },[])
    )]

    const answerList = quizData[0].data.quiz.data.questions.find(i=>i.data.questionId ===questionId).data.answers.data.map(i=>i.answerId);

    const alreadyExists= Object.values(selectedOptions).find(i=> JSON.stringify(i) === JSON.stringify(userSelectedOptions))

    if(userSelectedOptions.length){
        
      if (selectedOptionsWithId && Object.keys(selectedOptionsWithId).length > 0) {

        //clear optional  question from state on new primary question option select
          if(questionWithOptions.indexOf(questionId)!==-1 && !alreadyExists){

            for (let quesSelectId of conditionalQues){
              if(selectedOptionsWithId[quesSelectId]){
                const optionToRemoved = selectedOptionsWithId[quesSelectId].join();
                const questionIndex = Object.keys(selectedOptions).find(key => selectedOptions[key].includes(optionToRemoved));
                await handlers.removeQuizOptionSelected(questionIndex);
                await handlers.removeQuizOptionSelectedWithId(quesSelectId)
              }
            }
          }

          const option = selectedOptionsWithId[questionId];
          if (option) {
              index =  Object.keys(selectedOptions).find(key => selectedOptions[key].some(id => answerList.includes(id)));
          }else{
              index = Object.keys(selectedOptions).length
          }

      }

  
      await handlers.updateQuizOptionSelected(index, userSelectedOptions);
      await handlers.updateQuizOptionSelectedWithId(questionId, userSelectedOptions);
    }else{

      //gets answers arraylist based on quesitonID
      
      const questionIndex = Object.keys(selectedOptions).find(key => selectedOptions[key].some(id => answerList.includes(id)));
      await handlers.removeQuizOptionSelected(questionIndex);
      await handlers.removeQuizOptionSelectedWithId(questionId)
      //await handlers.updateQuizOptionSelected(index, userSelectedOptions);
   }

    let formattedData = await quizFormattedDatafn(quizData)
    await handlers.updateQuizFormattedData(formattedData);
    // dispacth clear error  event
    let event = new CustomEvent('event-clear-error', { detail: questionId });
    document.dispatchEvent(event);
  }
};

const quizQuestionHandler = question => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    console.log(question)
  }
};

const quizIntrohandler = () => {
  analyticsService?.registerEvent('event1', { page: `aiba quiz intro` });
};

export const getWeatherDropdownInitialisationProps = () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    return {
      rootQuerySelectorName: 'aiba-app',
      inputQuerySelectorName: 'autocomplete',
      initiasationProps: {
        types: ['geocode'],
        // componentRestrictions: { country: 'ID' },
      },
      apiKey: Env['WEATHER_API_KEY'] || '',
      scriptUrl: 'https://maps.googleapis.com/maps/api/js?key=[api_key]&libraries=places',
    };
  }
};

export const handlePlacesChanged = async (place: any) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];

    if (!place.geometry) {
      console.log("No details available for input: '" + place.name + "'");
      return;
    }

    // Get the latitude and longitude
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    await handlers.setWeatherCoordinates(`${lat},${lng}`);
  }
};

const loadDynamicQuestions = async (questions:any) => {

  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];

    try{
      const currentQuestionsSet = await handlers.getQuizAnalysisResultsFromState();
   
      const currentQuestionIds= currentQuestionsSet.reduce((total,curr)=> {
        curr?.questionId && total.push(curr.questionId);
        return total
      },[]);
      const questionsToShow = questions.filter(i=> currentQuestionIds.includes(i.data.questionId))
      return questionsToShow

    }catch(error){
      console.error('[error processing dynamic questions]: ',error);
      return questions
    }

  }
}

export { handleQuizScreenOnLoad, handleQuizOptionSelected, handleAnalyzeQuestionClick, quizQuestionHandler, quizIntrohandler, selectedOptions, loadDynamicQuestions, handleQuizScreenWillLoad };